import React from 'react'
import {css} from '@emotion/core'
import {Link} from 'gatsby'

import Layout from '../components/layouts/layout'
import {FadeIn} from '../components/fade-in'
import ToplineStat from '../components/topline-stats'
import {CaseStudyCarousel} from '../components/case-study-carousel'
import InlineAR from '../components/inline-ar'
import Picture from '../components/picture'

import buttonArrow from '../../img/button-arrow.svg'
import tryInArIcon from '../../img/try-in-ar-icon.svg'
import verified from '../../img/verified-badge.png'
import checkMark from '../../img/checkmark_developlicense_3x.png'
import mrcsDemoWebVideo1 from '../../img/vids/mrcs-demo-web-1.mp4'
import mrcsDemoWebVideo1Thumb from '../../img/vids/mrcs-demo-web-1.jpg'
import cloudEditorVid from '../../img/vids/homepage-cloud-editor.mp4'
import cloudEditorVidThumb from '../../img/vids/homepage-cloud-editor.jpg'
import faceEffectsImg from '../../img/face-effects-icon.svg'
import imageTargetImg from '../../img/image-target-icon.svg'
import worldTrackingImg from '../../img/world-tracking-icon.svg'
import heroVideo from '../../img/vids/hero-video-with-overlay.mp4'
import heroVideoThumb from '../../img/vids/hero-video-with-overlay.jpg'
import auggieImg from '../../img/auggie.svg'
import sxswImg from '../../img/sxsw-innovation-award.svg'
import integrationsIcon from '../../img/integrations-icon.png'
import adidasOriginalsLogo from '../../img/logos/adidas-originals.png'
import segaLogo from '../../img/logos/sega-logo.png'
import bmwLogo from '../../img/logos/bmw-logo.png'
import awsLogo from '../../img/logos/aws.png'
import redbullLogo from '../../img/logos/redbull.png'
import wsjLogo from '../../img/logos/wsj.png'
import swissairLogo from '../../img/logos/swissair.png'
import timeLogo from '../../img/logos/time.png'
import jergensLogo from '../../img/logos/jergens-logo.png'
import sonyLogo from '../../img/logos/sony.png'
import burgerKingLogo from '../../img/logos/burger-king-logo.png'
import porscheLogo from '../../img/logos/porsche-logo.png'
import britishgasLogo from '../../img/logos/britishgas.png'
import hyundaiLogo from '../../img/logos/hyundai.png'
import heinekenLogo from '../../img/logos/heineken.png'
import johnnieWalkerLogo from '../../img/logos/johnnie-walker-logo.png'
import coachLogo from '../../img/logos/coach.png'
import allyLogo from '../../img/logos/ally-logo.png'
import hsbcLogo from '../../img/logos/hsbc-logo.png'
import miniLogo from '../../img/logos/mini-logo.png'
import intimissimiLogo from '../../img/logos/intimissimi.png'
import toyotaLogo from '../../img/logos/toyota-logo.png'
import microsoftLogo from '../../img/logos/microsoft.png'
import aardmanLogo from '../../img/logos/aardman.png'
import adidasOriginalsLogoWebp from '../../img/logos/adidas-originals.webp'
import segaLogoWebp from '../../img/logos/sega-logo.webp'
import bmwLogoWebp from '../../img/logos/bmw-logo.webp'
import awsLogoWebp from '../../img/logos/aws.webp'
import redbullLogoWebp from '../../img/logos/redbull.webp'
import wsjLogoWebp from '../../img/logos/wsj.webp'
import swissairLogoWebp from '../../img/logos/swissair.webp'
import timeLogoWebp from '../../img/logos/time.webp'
import jergensLogoWebp from '../../img/logos/jergens-logo.webp'
import sonyLogoWebp from '../../img/logos/sony.webp'
import burgerKingLogoWebp from '../../img/logos/burger-king-logo.webp'
import porscheLogoWebp from '../../img/logos/porsche-logo.webp'
import britishgasLogoWebp from '../../img/logos/britishgas.webp'
import hyundaiLogoWebp from '../../img/logos/hyundai.webp'
import heinekenLogoWebp from '../../img/logos/heineken.webp'
import johnnieWalkerLogoWebp from '../../img/logos/johnnie-walker-logo.webp'
import coachLogoWebp from '../../img/logos/coach.webp'
import allyLogoWebp from '../../img/logos/ally-logo.webp'
import hsbcLogoWebp from '../../img/logos/hsbc-logo.webp'
import miniLogoWebp from '../../img/logos/mini-logo.webp'
import intimissimiLogoWebp from '../../img/logos/intimissimi.webp'
import toyotaLogoWebp from '../../img/logos/toyota-logo.webp'
import microsoftLogoWebp from '../../img/logos/microsoft.webp'
import aardmanLogoWebp from '../../img/logos/aardman.webp'
import faceEffectsVid from '../../img/vids/face-tracking-for-homepage.mp4'
import faceEffectsVidThumb from '../../img/vids/face-tracking-for-homepage.jpg'
import imageTargetsVid from '../../img/vids/image-targets-for-homepage.mp4'
import imageTargetsVidThumb from '../../img/vids/image-targets-for-homepage.jpg'
import PartnerCarousel from '../components/partners-carousel'
import SocialProofSection from '../components/social-proof-section'

export const ARSolutionHighlight = ({img, description, maxWidth, last = false}) => (
  <div className='col-md-3 col-sm-12'>
    <img
      src={img}
      className='img-fluid text-center'
      style={{maxWidth, marginBottom: '1em'}}
      alt='AR Solution Icon'
    />
    <p
      css={css`
        margin: 0 auto;
        max-width: 11em;
        font-weight: 900 !important;
        @media screen and (max-width: 767px) {
          margin-bottom: ${last ? '0em' : '2em'};
        }
      `}
    >
      {description}
    </p>
  </div>
)

const MainContent = () => {
  const statRef = React.useRef<HTMLDivElement>(null!)
  const [isStatVisible, setStatVisible] = React.useState(false)
  const [email, setEmail] = React.useState('')
  const [isFaceEffectsRunning, setIsFaceEffectsRunning] = React.useState(false)
  const [isWorldTrackingRunning, setIsWorldTrackingRunning] = React.useState(false)
  const freeTrialSubmit = (e) => {
    e.preventDefault()
    sessionStorage.setItem(
      'free-trial.email',
      email
    )
    window.location.href = '/try-free-trial'
  }

  React.useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setStatVisible(true)
        }
      })
    })
    observer.observe(statRef.current)
    return () => observer.unobserve(statRef.current)
  }, [])

  return (
    <>
      <section className='jumbovid-section'>
        <video id='jumbovid' autoPlay muted loop playsInline>
          <source src={heroVideo} type='video/mp4' poster={heroVideoThumb} />
          Your browser does not support HTML5 video.
        </video>

        <FadeIn translateAmount='0' transitionDuration={600}>
          <div
            className='container-fluid homepage'
          >
            <div className='jumbotron-fluid jumbotronMinHeight d-flex flex-column justify-content-center'>
              <div className='row justify-content-center'>
                <div className='col hero-content'>
                  <h1>Powerful tools to create extraordinary WebAR content</h1>
                  <p>{'Use 8th Wall\'s powerful platform to develop augmented reality that works on all devices— no app required'}</p>
                  <div className='row align-items-center hero-buttons'>
                    <a
                      className='order-last order-md-first text-center text-md-left'
                      id='hero-anchor-button'
                      href='https://8th.io/demo'
                      target='_blank'
                      rel='noopener noreferrer'
                      a8='click;purchase-intent;view-demo'
                    >
                      Try Demo
                    </a>
                    <a
                      className='text-center text-md-left'
                      id='hero-anchor-button-dark'
                      href='/try-free-trial'
                      a8='click;click-free-trial-cta;primary-free-trial-cta'
                    >
                      Try 14 Days Free
                      <img
                        src={buttonArrow}
                        alt='Right arrow'
                        style={{marginBottom: '6px', marginLeft: '10px'}}
                      />
                    </a>
                  </div>
                  <div
                    className='row justify-content-center justify-content-md-start'
                    css={css`
                      margin-left: 0.2em;
                      @media screen and (max-width: 767px) {
                        margin-left: -2em;
                        margin-bottom: 1em;
                      }
                    `}
                  >
                    <img
                      src={auggieImg}
                      id='homepage-award'
                      alt='2019 Auggie Award'
                    />
                    <img
                      src={sxswImg}
                      id='homepage-award'
                      alt='2019 Auggie Award'
                      css={css`
                        margin-left: 3em;
                        @media screen and (max-width: 767px) {
                          margin-left: 2em;
                        }
                      `}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </section>

      <FadeIn>
        <section className='container-fluid homepage large-content'>
          <div className='row justify-content-center text-center'>
            <div className='col-10' style={{marginBottom: '0.2em'}}>
              <h2>Interactive AR in Your Browser</h2>
            </div>
          </div>
          <div
            className='row justify-content-center text-center'
            style={{marginBottom: '2em'}}
          >
            <div className='col-11 max-width'>
              <p style={{whiteSpace: 'pre-line'}}>
                8th Wall is the world-class developer platform that lets you harness the full power and freedom of the web to create meaningful augmented reality experiences.
              </p>
            </div>
          </div>

          <div className='row justify-content-center text-center'>
            <ARSolutionHighlight
              img={worldTrackingImg}
              description='Place interactive 3D in your space with World Tracking'
              maxWidth='4.0em'
            />
            <ARSolutionHighlight
              img={faceEffectsImg}
              description='Try on accessories, face filters and more with Face Effects'
              maxWidth='2.6em'
            />
            <ARSolutionHighlight
              img={imageTargetImg}
              description='Bring print & packaging to life with Image Targets'
              maxWidth='4.4em'
              last
            />
          </div>
        </section>
      </FadeIn>

      <SocialProofSection fadeIn a8='click;click-free-trial-cta;secondary-free-trial-cta' />

      <section className='container-fluid homepage large-content' style={{background: '#F9F9FA'}}>
        <FadeIn>
          <div className='row justify-content-center text-center'>
            <div className='col-11 max-width'>
              <h2>
                {'8th Wall\'s Powerful AR Engine is Hyper-Optimized for the Browser and Works Across All Devices'}
              </h2>
              <p style={{marginTop: '0.75em'}}>
                Use the 8th Wall SDK to develop rich, interactive WebAR content
              </p>
            </div>
          </div>

          <div className='row justify-content-center align-items-lg-center align-items-start nunito' style={{marginTop: '2em'}}>
            <div className='order-last order-lg-first col-lg-4 col-10' style={{maxWidth: '600px'}}>
              {/* TODO(kyle) Fix how these Links are centered */}
              <button
                type='button'
                className='d-block d-md-inline-block d-lg-none offset-md-4'
                id='inline-ar-btn'
                a8='click;homepage;click-try-face-effects'
                onClick={() => { setIsFaceEffectsRunning(true) }}
                css={css`
                  text-align: center;
                  margin-top: 1.5em;
                  margin-bottom: 0.8em;
                  margin-left: 10.55em;
                  @media screen and (max-width: 767px) {
                    width: 100%;
                    margin-left: 0;
                  }
                `}
              >
                <img
                  src={tryInArIcon}
                  alt='Try in AR icon'
                  css={css`
                    max-height: 1.5em;
                    margin-right: 0.5em;
                  `}
                />
                Try Face Effects
              </button>
              <h4
                css={css`
                  margin-bottom: 1em !important;
                  @media screen and (max-width: 991px) {
                    margin-bottom: 0 !important;
                  }
                `}
              >Face Effects
              </h4>
              <p
                css={css`
                  margin-bottom: 1.5em;
                  @media screen and (max-width: 991px) {
                    margin-bottom: 1em;
                  }
                `}
              >
                Anchor 3D objects to attachment points or apply custom designs to a face mesh to create
                high-quality face filters. Face Effects work across all smartphones and desktops and can be
                captured and shared with our in-browser photo and video recording feature.
              </p>
              <button
                type='button'
                className='d-none d-lg-inline'
                id='inline-ar-btn'
                onClick={() => { setIsFaceEffectsRunning(true) }}
                a8='click;homepage;click-try-face-effects'
                style={{padding: '0.4em 1.2em'}}
              >
                <img
                  src={tryInArIcon}
                  alt='Try in AR icon'
                  css={css`
                    max-height: 1.5em;
                    margin-right: 0.5em;
                  `}
                />
                Try Face Effects
              </button>
              <div style={{marginBottom: '1em'}} />
            </div>
            <div className='device right device-iphone-x'>
              <div className='device-frame'>
                {isFaceEffectsRunning
                  ? <InlineAR url='https://8w.8thwall.app/face-effects' isVisibleCallback={setIsFaceEffectsRunning} />
                  : <video
                    className='device-content'
                    autoPlay
                    loop
                    muted
                    playsInline
                    src={faceEffectsVid}
                    poster={faceEffectsVidThumb}
                  />
                }
              </div>
              <div className='device-stripe' />
              <div className='device-header' />
              <div className='device-sensors' />
              <div className='device-btns' />
              <div className='device-power' />
            </div>
          </div>

          <div className='row justify-content-center align-items-center nunito' style={{marginTop: '2em'}}>
            <div className='order-last col-lg-4 col-10' style={{maxWidth: '600px'}}>
              <Link
                a8='click;homepage;click-explore-world-tracking'
                className='d-block d-md-inline-block d-lg-none offset-md-4'
                to='/products-web#world-tracking'
                id='anchor-button-dark'
                css={css`
                  text-align: center;
                  margin-top: 1.5em;
                  margin-bottom: 0.8em;
                  margin-left: 10em;
                  @media screen and (max-width: 767px) {
                    margin-left: 0;
                  }
                `}
              >
                Explore World Tracking
              </Link>
              <h4
                css={css`
                  margin-bottom: 1em !important;
                  @media screen and (max-width: 991px) {
                    margin-bottom: 0 !important;
                  }
                `}
              >World Tracking
              </h4>
              <p
                css={css`
                  margin-bottom: 2em;
                  @media screen and (max-width: 991px) {
                    margin-bottom: 1em;
                  }
                `}
              >
                8th Wall&apos;s instant surface detection, lighting estimation and relative scale lets
                users experience realistic 3D assets, volumetric video and animations in their own environment
                without the need to waive their phone or resize content. World Tracking works across
                both iOS and Android devices.
              </p>
              <Link
                a8='click;homepage;click-explore-world-tracking'
                className='d-none d-lg-inline'
                to='/products-web#world-tracking'
                id='anchor-button-dark'
              >Explore World Tracking
              </Link>
              <div style={{marginBottom: '1em'}} />
            </div>
            <div className='device left device-iphone-x'>
              <div className='device-frame'>
                {isWorldTrackingRunning
                  ? <InlineAR
                    url='https://8w.8thwall.app/mrcs-inline/'
                    isVisibleCallback={setIsWorldTrackingRunning}
                    requireRegisterXRIFrame
                  />
                  : <video
                    className='device-content'
                    autoPlay
                    loop
                    muted
                    playsInline
                    src={mrcsDemoWebVideo1}
                    poster={mrcsDemoWebVideo1Thumb}
                  />
                }
              </div>
              <div className='device-stripe' />
              <div className='device-header' />
              <div className='device-sensors' />
              <div className='device-btns' />
              <div className='device-power' />
            </div>
          </div>

          <div className='row justify-content-center align-items-center nunito' style={{marginTop: '2em'}}>
            <div className='order-last order-lg-first col-lg-4 col-10' style={{maxWidth: '600px'}}>
              <Link
                a8='click;homepage;click-explore-image-targets'
                className='d-block d-md-inline-block d-lg-none offset-md-4'
                to='/products-web#image-target'
                id='anchor-button-dark'
                css={css`
                  text-align: center;
                  margin-top: 1.5em;
                  margin-bottom: 0.8em;
                  margin-left: 10em;
                  @media screen and (max-width: 767px) {
                    margin-left: 0;
                  }
                `}
              >Explore Image Targets
              </Link>
              <h4
                css={css`
                  margin-bottom: 1em !important;
                  @media screen and (max-width: 991px) {
                    margin-bottom: 0 !important;
                  }
                `}
              >Image Targets
              </h4>
              <p
                css={css`
                  margin-bottom: 2em;
                  @media screen and (max-width: 991px) {
                    margin-bottom: 1em;
                  }
                `}
              >
                Upload endless image targets including packaging, logos, signage, posters, ads, labels
                and more to trigger or interact with WebAR content. Projects may combine image targets
                and world tracking for a truly interactive experience. Image Targets work on both flat
                and curved surfaces such as bottles, cups and cans across both iOS and Android devices.
              </p>
              <Link
                a8='click;homepage;click-explore-image-targets'
                className='d-none d-lg-inline'
                to='/products-web#image-target'
                id='anchor-button-dark'
              >Explore Image Targets
              </Link>
              <div style={{marginBottom: '1em'}} />
            </div>
            <div className='device right device-iphone-x'>
              <div className='device-frame'>
                <video
                  className='device-content'
                  autoPlay
                  loop
                  muted
                  playsInline
                  src={imageTargetsVid}
                  poster={imageTargetsVidThumb}
                />
              </div>
              <div className='device-stripe' />
              <div className='device-header' />
              <div className='device-sensors' />
              <div className='device-btns' />
              <div className='device-power' />
            </div>
          </div>
        </FadeIn>
      </section>

      <svg className='d-none d-md-block' xmlns='http://www.w3.org/2000/svg' viewBox='0 60 1440 170'>
        <path fill='#F9F9FA' fillOpacity='1' d='M0,224L60,224C120,224,240,224,360,213.3C480,203,600,181,720,160C840,139,960,117,1080,106.7C1200,96,1320,96,1380,96L1440,96L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z' />
      </svg>
      <svg className='d-block d-md-none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 280'>
        <path fill='#F9F9FA' fillOpacity='1' d='M0,224L60,224C120,224,240,224,360,213.3C480,203,600,181,720,160C840,139,960,117,1080,106.7C1200,96,1320,96,1380,96L1440,96L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z' />
      </svg>

      <section className='container-fluid homepage'>
        <FadeIn>
          <>
            <div className='row justify-content-center text-center'>
              <h2>Powered by 8th Wall</h2>
            </div>

            <div className='row justify-content-center text-center' style={{margin: '1em 0'}}>
              <p style={{whiteSpace: 'pre-line'}}>
                {'Case studies and award-winning WebAR campaigns\ndeveloped by our partners'}
              </p>
            </div>

            <CaseStudyCarousel from='homepage' />

            <div className='row justify-content-center text-center'>
              <div className='col-10' style={{maxWidth: '1025px'}}>
                <blockquote>
                  The tracking quality and working speed is fantastic. We have tried most AR libraries on the market and can say with confidence 8th Wall is the leading technology now.
                </blockquote>
              </div>
            </div>
            <div className='row justify-content-center text-right'>
              <div className='col-10 max-width'>
                <p
                  css={css`
                    margin-top: -1em;
                    margin-bottom: 2em;
                    color: #8083A2 !important;
                    color: #8083A2;
                    font-weight: 700 !important;
                    font-size: 1.6em !important;
                    @media screen and (max-width: 991px) {
                      font-size: 1.4em !important;
                    }
                  `}
                >
                  —Andrew Gafarov, Production Director and CTO for Mosaic
                </p>
              </div>
            </div>

            <div className='row justify-content-center align-items-center text-center' style={{marginTop: '1em'}}>
              <Picture
                className='img-fluid brand-logo d-none d-lg-block'
                pngSrc={adidasOriginalsLogo}
                webpSrc={adidasOriginalsLogoWebp}
                alt='Adidas Logo'
              />
              <Picture
                className='img-fluid brand-logo d-none d-lg-block'
                pngSrc={segaLogo}
                webpSrc={segaLogoWebp}
                alt='Sega Logo'
              />
              <Picture
                className='img-fluid brand-logo'
                pngSrc={awsLogo}
                webpSrc={awsLogoWebp}
                alt='AWS Logo'
              />
              <Picture
                className='img-fluid brand-logo'
                pngSrc={redbullLogo}
                webpSrc={redbullLogoWebp}
                alt='Redbull Logo'
              />
              <Picture
                className='img-fluid brand-logo'
                pngSrc={wsjLogo}
                webpSrc={wsjLogoWebp}
                alt='WSJ Logo'
              />
              <Picture
                className='img-fluid brand-logo d-none d-lg-block'
                pngSrc={swissairLogo}
                webpSrc={swissairLogoWebp}
                alt='Swiss Air Logo'
              />
            </div>

            <div className='row justify-content-center align-items-center text-center' style={{marginTop: '2em'}}>
              <Picture
                className='img-fluid brand-logo d-none d-lg-block'
                pngSrc={timeLogo}
                webpSrc={timeLogoWebp}
                alt='Time Logo'
              />
              <Picture
                className='img-fluid brand-logo d-none d-lg-block'
                pngSrc={jergensLogo}
                webpSrc={jergensLogoWebp}
                alt='Jergens Logo'
              />
              <Picture
                className='img-fluid brand-logo'
                pngSrc={sonyLogo}
                webpSrc={sonyLogoWebp}
                alt='Sony Logo'
              />
              <Picture
                className='img-fluid brand-logo'
                pngSrc={burgerKingLogo}
                webpSrc={burgerKingLogoWebp}
                alt='Burger King Logo'
              />
              <Picture
                className='img-fluid brand-logo'
                pngSrc={porscheLogo}
                webpSrc={porscheLogoWebp}
                alt='Porsche Logo'
              />
              <Picture
                className='img-fluid brand-logo d-none d-lg-block'
                pngSrc={britishgasLogo}
                webpSrc={britishgasLogoWebp}
                alt='British Gas Logo'
              />
            </div>

            <div className='row justify-content-center align-items-center text-center' style={{marginTop: '2em'}}>
              <Picture
                className='img-fluid brand-logo d-none d-lg-block'
                pngSrc={hyundaiLogo}
                webpSrc={hyundaiLogoWebp}
                alt='Hyundai Logo'
              />
              <Picture
                className='img-fluid brand-logo d-none d-lg-block'
                pngSrc={heinekenLogo}
                webpSrc={heinekenLogoWebp}
                alt='Heineken Logo'
              />
              <Picture
                className='img-fluid brand-logo'
                pngSrc={bmwLogo}
                webpSrc={bmwLogoWebp}
                alt='Lego Logo'
              />
              <Picture
                className='img-fluid brand-logo'
                pngSrc={johnnieWalkerLogo}
                webpSrc={johnnieWalkerLogoWebp}
                alt='Johnnie Walker Logo'
              />
              <Picture
                className='img-fluid brand-logo'
                pngSrc={coachLogo}
                webpSrc={coachLogoWebp}
                alt='Coach Logo'
              />
              <Picture
                className='img-fluid brand-logo d-none d-lg-block'
                pngSrc={allyLogo}
                webpSrc={allyLogoWebp}
                alt='Ally Logo'
              />
            </div>

            <div className='row justify-content-center align-items-center text-center' style={{marginTop: '2em'}}>
              <Picture
                className='img-fluid brand-logo d-none d-lg-block'
                pngSrc={hsbcLogo}
                webpSrc={hsbcLogoWebp}
                alt='HSBC Logo'
              />
              <Picture
                className='img-fluid brand-logo d-none d-lg-block'
                pngSrc={miniLogo}
                webpSrc={miniLogoWebp}
                alt='Mini Logo'
              />
              <Picture
                className='img-fluid brand-logo d-none d-lg-block'
                pngSrc={intimissimiLogo}
                webpSrc={intimissimiLogoWebp}
                alt='Intimissimi Logo'
              />
              <Picture
                className='img-fluid brand-logo d-none d-lg-block'
                pngSrc={toyotaLogo}
                webpSrc={toyotaLogoWebp}
                alt='Toyota Logo'
              />
              <Picture
                className='img-fluid brand-logo d-none d-lg-block'
                pngSrc={microsoftLogo}
                webpSrc={microsoftLogoWebp}
                alt='Microsoft Logo'
              />
              <Picture
                className='img-fluid brand-logo d-none d-lg-block'
                pngSrc={aardmanLogo}
                webpSrc={aardmanLogoWebp}
                alt='Aardman Logo'
              />
            </div>

            <div
              className='row justify-content-center text-center'
              style={{margin: '3em 0 1em'}}
            >
              <div className='col'>
                <Link
                  a8='click;homepage;click-see-customer-work'
                  to='/customer-work'
                  id='anchor-button-dark'
                >See customer work
                </Link>
              </div>
            </div>
          </>
        </FadeIn>
      </section>

      <section
        className='container-fluid homepage dark'
        style={{background: '#7611B7', overflowX: 'hidden'}}
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 90 1440 200'
          css={css`
            margin: -4em -2em;
            @media (min-width: 768px) and (max-width: 991px) {
              margin: -2em;
            }
            @media screen and (max-width: 767px) {
              margin: -0.1em -2em;
            }
          `}
        >
          <path fill='#FFF' fillOpacity='1' d='M0,160L60,170.7C120,181,240,203,360,213.3C480,224,600,224,720,218.7C840,213,960,203,1080,213.3C1200,224,1320,256,1380,272L1440,288L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z' />
        </svg>
        <FadeIn>
          <div className='large-content'>
            <div className='row justify-content-center text-center'>
              <div className='col-10'>
                <h2>Reach Twice as Many Mobile Devices</h2>
              </div>
            </div>

            <div ref={statRef} className='row justify-content-center'>
              <div className='col-10 max-width'>
                <div className='row justify-content-center nunito'>
                  <div className='col' style={{marginBottom: '-1em'}}>
                    <div className='float-left'>
                      <p style={{fontWeight: 700}}>8th Wall WebAR</p>
                    </div>
                    <div className='float-right'>
                      <p>2.9 Billion</p>
                    </div>
                  </div>
                </div>

                <div className='row justify-content-start nunito'>
                  <div className='col'>
                    <div className='progress center-block' style={{height: '3em', backgroundColor: '#7611B7'}}>
                      <div
                        className='progress-bar'
                        role='progressbar'
                        style={{width: isStatVisible ? '100%' : '0%', background: 'linear-gradient(to right, #AD50FF, #F6C4FE)'}}
                      />
                    </div>
                  </div>
                </div>

                <div className='row justify-content-start nunito' style={{marginTop: '0.8em'}}>
                  <div className='col-4'>
                    <div className='progress center-block' style={{height: '3em', backgroundColor: '#7611B7'}}>
                      <div
                        className='progress-bar'
                        role='progressbar'
                        style={{width: isStatVisible ? '100%' : '0%', background: 'linear-gradient(to right, #AD50FF, #F6C4FE)'}}
                      />
                    </div>
                  </div>
                  <p>ARKit</p>
                </div>

                <div
                  className='row justify-content-start nunito'
                  css={css`
                    margin-top: -0.5em;
                    @media screen and (max-width: 767px) {
                      margin-top: 0;
                    }
                  `}
                >
                  <div className='col-2'>
                    <div className='progress center-block' style={{height: '3em', backgroundColor: '#7611B7'}}>
                      <div
                        className='progress-bar'
                        role='progressbar'
                        style={{width: isStatVisible ? '100%' : '0%', background: 'linear-gradient(to right, #AD50FF, #F6C4FE)'}}
                      />
                    </div>
                  </div>
                  <p>ARCore</p>
                </div>

                <div className='row justify-content-start nunito d-none d-md-block'>
                  <div className='col'>
                    <p style={{fontSize: '1em'}}>Source: ARtillery Intelligence’s&nbsp;
                      <a
                        target='_blank'
                        rel='noopener noreferrer'
                        href='https://arinsider.co/2019/07/09/ar-revenues-to-reach-27-4-billion-by-2023/'
                        style={{color: 'white', textDecoration: 'underline'}}
                      >AR Global Revenue Forecast, 2018-2023
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div className='row justify-content-center text-center' style={{marginTop: '2em'}}>
                <h2 style={{marginBottom: '0em'}}>Drive Meaningful Results</h2>
              </div>
            </div>
            <div className='row justify-content-center text-center'>
              <FadeIn
                className='col-12 col-sm-4 align-self-end'
                translateAmount='20px'
                delay={200}
                transitionDuration={800}
                transitionType='ease-out'
                id='case-study-stat'
              >
                <ToplineStat
                  key='First Stat'
                  stat={{
                    valueStart: 0,
                    staticPrefix: '>',
                    valueEnd: 1,
                    staticSuffix: 'min',
                    footer: '80% of users spend more than 1 minute engaging',
                    trailColor: '#5D0E90',
                    actualEnd: 0.9,
                  }}
                  index={0}
                />
                <ToplineStat
                  key='Second Stat'
                  stat={{
                    valueStart: 0,
                    staticPrefix: '>',
                    valueEnd: 2,
                    staticSuffix: 'min',
                    footer: '50% of users spend more than 2 minutes engaging',
                    trailColor: '#5D0E90',
                    actualEnd: 1.01,
                    roundUp: true,
                  }}
                  index={0}
                />
              </FadeIn>
            </div>
          </div>
        </FadeIn>
      </section>

      <section className='container-fluid homepage large-content' style={{backgroundColor: '#EBEBF1'}}>
        <FadeIn>
          <>
            <div className='row justify-content-center text-center'>
              <div className='col-12' style={{marginBottom: '1em'}}>
                <h2>Create, Collaborate and Publish — All in One Place</h2>
              </div>
            </div>

            <div className='row justify-content-center align-items-start text-center'>
              <div className='col-10' style={{marginBottom: '0em'}}>
                <p>8th Wall&apos;s Cloud Editor is the best way to develop WebAR content</p>
              </div>
            </div>
            <div className='row justify-content-center nunito' style={{marginTop: '2em'}}>
              <div className='order-last col-3 flex-wrap features-column' style={{maxWidth: '600px', marginRight: '1.2em'}}>
                <div className='row flex-nowrap'>
                  <img className='check-mark' src={checkMark} alt='Check Mark' />
                  <p>{'Fully-Featured\nCode Editor'}</p>
                </div>
                <div className='row flex-nowrap'>
                  <img className='check-mark' src={checkMark} alt='Check Mark' />
                  <p>Project Templates</p>
                </div>
                <div className='row flex-nowrap'>
                  <img className='check-mark' src={checkMark} alt='Check Mark' />
                  <p>Remote Debugger</p>
                </div>
                <div className='row flex-nowrap'>
                  <img className='check-mark' src={checkMark} alt='Check Mark' />
                  <p>Source Control</p>
                </div>
                <div className='row flex-nowrap'>
                  <img className='check-mark' src={checkMark} alt='Check Mark' />
                  <p>Unlimited Seats</p>
                </div>
                <div className='row flex-nowrap'>
                  <img className='check-mark' src={checkMark} alt='Check Mark' />
                  <p>Built-in Hosting</p>
                </div>
                <div
                  className='row'
                  css={css`
                    margin-top: 2em;
                    @media screen and (max-width: 991px) {
                      margin-top: 1em;
                    }
                  `}
                >
                  <Link
                    a8='click;homepage;click-explore-features'
                    style={{whiteSpace: 'nowrap'}}
                    to='/products-web'
                    id='anchor-button-dark'
                  >Explore features
                  </Link>
                </div>
              </div>
              <div className='device device-macbook-pro'>
                <div className='device-frame'>
                  <video
                    className='device-content'
                    autoPlay
                    loop
                    muted
                    playsInline
                    src={cloudEditorVid}
                    poster={cloudEditorVidThumb}
                  />
                </div>
                <div className='device-stripe' />
                <div className='device-header' />
                <div className='device-sensors' />
                <div className='device-btns' />
                <div className='device-power' />
              </div>
            </div>
          </>
        </FadeIn>
      </section>

      <section className='container-fluid homepage small-content d-none d-lg-block' style={{background: '#7611B7'}}>
        <FadeIn>
          <div className='row justify-content-center align-items-center text-left' style={{padding: '0 1em'}}>
            <img src={integrationsIcon} alt='Integrations Icon' style={{maxWidth: '5em', margin: '0 2em 0.9em 0'}} />
            <p style={{color: 'white', whiteSpace: 'pre-line'}}>
              <b style={{fontWeight: 900}}>Integrations</b>{': 8th Wall supports popular 3D frameworks such as\nA-Frame, three.js, Babylon.js, PlayCanvas and more. '}
              <a
                style={{color: 'white', textDecoration: 'underline', fontWeight: 300}}
                href='/docs/web'
                target='_blank'
                rel='noopener noreferrer'
                a8='click;homepage;click-refer-to-docs'
              >Refer to Docs
              </a>
            </p>
          </div>
        </FadeIn>
      </section>

      <div className='container-fluid homepage large-content' style={{background: '#F9F9FA'}}>
        <FadeIn>
          <>
            <div className='row justify-content-center text-center'>
              <div className='col'>
                <h2>
                  8th Wall Partners
                  <img src={verified} className='verified-badge' alt='Verified Badge' />
                </h2>
              </div>
            </div>
            <div className='row justify-content-center text-center' style={{marginTop: '1em'}}>
              <div className='col-10 max-width'>
                <p>Agencies and production partners that Fortune 500 brands count on to create extraordinary WebAR content</p>
              </div>
            </div>
            <PartnerCarousel from='homepage' />
            <div className='row justify-content-center text-center'>
              <a
                id='anchor-button-dark'
                href='https://www.8thwall.com/partners'
                a8='click;homepage;click-find-a-partner'
              >
                Find an 8th Wall Partner
              </a>
            </div>
            <div className='row justify-content-center text-center' style={{marginTop: '1em'}}>
              <a
                target='_blank'
                rel='noopener noreferrer'
                href='https://docs.google.com/forms/d/e/1FAIpQLSc-fUqG-aJxOOgpmf2zAwhqG5IbW_DECLerxKDquN-dLG9bVw/viewform'
                a8='click;homepage;click-become-a-partner-form'
                css={css`
                  font-size: 1.3em;
                  text-decoration: underline;
                `}
              >
                Apply online to become an official Partner
              </a>
            </div>
          </>
        </FadeIn>
      </div>

      <section
        className='container-fluid small-content'
        style={{background: 'linear-gradient(to right, #7611B7, #ad50ff)', zIndex: 2, position: 'relative'}}
      >
        <div className='row justify-content-center' style={{alignItems: 'center'}}>
          <div
            className='col-lg-6 col-md-6 col-sm-12 col-12 text-center text-sm-center text-md-center text-lg-right my-auto'
          >
            <h2 className='white' style={{marginBottom: '1em', marginTop: '1em', fontFamily: 'Noto Sans JP, sans-serif', fontWeight: 700}}>
              Start a 14-Day Free Trial of 8th Wall
            </h2>
          </div>

          <div
            className='col-lg-6 col-md-6 col-sm-12 col-12 text-center text-sm-center text-md-center text-lg-left'
            style={{margin: '1em 0'}}
          >

            <form className='input-group' style={{width: '100%'}} id='getStartedForm' onSubmit={freeTrialSubmit}>
              <input
                className='form-control'
                style={{borderTopLeftRadius: '18px', borderBottomLeftRadius: '18px', textIndent: '10px'}}
                type='email'
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder='Enter your work email'
              />
              <div className='input-group-append'>
                <button className='btn-primary newsletter-btn' type='submit' a8='click;click-free-trial-cta;bottom-page-cta'>
                  Get started
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  )
}

export default () => (
  <Layout
    title='Powerful Tools to Create Extraordinary WebAR, AR, WebVR Experiences'
    description='Create, collaborate and publish interactive augmented reality content to the web in real time with 8th Wall. Start developing now with a 14-day free trial.'
    a8='scroll;homepage;scrolling'
  >
    <MainContent />
  </Layout>
)
